<template>
  <footer class="footer">
    <section class="footer-content">
      <div class="footer-content__top footer__flex">
        <RouterLink to="/" class="logo footer__logo">
          <app-svg icon="logo" width="180" height="76" />
        </RouterLink>

        <nav class="footer__nav">
          <ul class="footer__nav-list">
            <li class="footer__nav-item">
              <a href="#why-soda" class="footer-link">Why Soda?</a>
            </li>
            <li class="footer__nav-item">
              <a href="#how-to-use" class="footer-link">How to Use</a>
            </li>
            <li class="footer__nav-item">
              <a href="#faq" class="footer-link">FAQs</a>
            </li>
          </ul>
        </nav>
        <DownloadLink class="footer__btn" />
      </div>

      <div class="footer-content__bottom footer__flex">
        <div class="footer-disclaimer">
          <RouterLink to="/privacy" class="footer__title footer-link">
            Privacy Policy
          </RouterLink>

          <div class="footer__text">
            Terms of Use: By using Soda Connect, you agree to comply with the
            laws of the country you are located in.
            <br class="d-sm-inline" />The developer is not responsible for any
            use of the app that violates applicable laws.
          </div>
        </div>

        <div class="footer__address">
          <div class="footer__title">Address:</div>

          <address class="footer__text">
            30/10 Moo 1,<br />
            83130, Mueang Phuket, Thailand
          </address>
        </div>
      </div>
    </section>

    <img class="footer__code" src="@/assets/img/qr.svg" alt="qr code" />
  </footer>
</template>

<script setup>
import DownloadLink from './DownloadLink.vue'
</script>
